var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconClasses(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.326,
    height: 25.088,
    viewBox: "0 0 26.326 25.088",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#c7c6d6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2px",
    d: "M348.485 529.927l10.7 9.267a1.366 1.366 0 0 1 .154 1.893c-.468.566-1.734.008-1.734.008v10.674a.83.83 0 0 1-.82.839h-6.445v-9.216h-5.44v9.216h-6.445a.83.83 0 0 1-.82-.839V541.1s-1.264.558-1.732-.008a1.365 1.365 0 0 1 .154-1.893l10.7-9.267a1.292 1.292 0 0 1 1.7 0z",
    transform: "translate(1.135 1.088) translate(-335.591 -529.609)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClasses);
export default __webpack_public_path__ + "static/media/icon-classes.ce27add770d907440398f96455bb3339.svg";
export { ForwardRef as ReactComponent };